"use client";

import { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { TextInput, Button, Alert, Spinner } from "flowbite-react";

type NewsletterFormInputs = {
  email: string;
};

const NewsletterForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<NewsletterFormInputs>();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onSubmit: SubmitHandler<NewsletterFormInputs> = async (data) => {
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const response = await fetch("/api/newsletter/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: data.email }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage(result.message || "Merci pour votre inscription ! 🎉");
      } else {
        throw new Error(
          result.error || "Une erreur s'est produite, veuillez réessayer.",
        );
      }
    } catch (err: any) {
      setError(
        "Impossible de vous inscrire pour le moment. Veuillez réessayer.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto mt-12 max-w-md rounded-lg bg-white p-6 shadow-md dark:bg-gray-900">
      {/* 🔹 Add margin-top (mt-8 for spacing) */}
      <h2 className="mb-4 text-center text-xl font-semibold text-gray-900 dark:text-white">
        📩 Abonnez-vous à notre newsletter
      </h2>
      <p className="mb-4 text-center text-sm text-gray-600 dark:text-gray-300">
        Recevez les dernières actualités et analyses directement dans votre
        boîte mail.
      </p>

      {message && <Alert color="success">{message}</Alert>}
      {error && <Alert color="failure">{error}</Alert>}

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col space-y-3"
      >
        {/* 🔹 Champ Email */}
        <TextInput
          type="email"
          placeholder="Votre adresse e-mail"
          {...register("email", {
            required: "L'email est requis",
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              message: "Adresse e-mail invalide",
            },
          })}
          color={errors.email ? "failure" : "gray"}
        />
        {errors.email && (
          <p className="text-xs text-red-500">{errors.email.message}</p>
        )}

        {/* 🔹 Bouton de soumission */}
        <Button type="submit" color="blue" disabled={loading}>
          {loading ? <Spinner size="sm" /> : "S'inscrire"}
        </Button>
      </form>
    </div>
  );
};

export default NewsletterForm;
